import { i18next } from '@hotjar/translations';

export interface BaseAttributes {
  [key: string]: string | number | boolean | undefined;
}

abstract class BaseTarget {
  entityId: string | number | undefined;

  locale: string | null;

  constructor({ id }: { id: string | number | undefined }) {
    if (this.constructor === BaseTarget) {
      throw new Error('Cannot instantiate BaseTarget class directly.');
    }

    this.entityId = id;
    this.locale = i18next.languages?.[0] ?? null;
  }

  // FIXME: Consider using a static method.
  // eslint-disable-next-line class-methods-use-this
  get prefix(): string {
    return 'id';
  }

  get id(): string {
    return `${this.prefix}-${this.entityId}`;
  }

  get attributes(): BaseAttributes {
    const attributes: BaseAttributes = {};

    if (this.locale !== null) {
      attributes.locale = this.locale;
    }

    return attributes;
  }

  validate(): boolean {
    return this.entityId !== undefined;
  }
}

export { BaseTarget };
